import { useAuth } from '@/contexts/AuthContext';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function SignUp() {
  const navigate = useNavigate();
  const { signup, isLoading, error } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    // referralCode: '',
    password: '',
    confirmPassword: '',
    username: '',
    // usdtWallet: '',
    // withdrawalPin: '',
    // phoneCountryCode: '+82',
    // phoneNumber: '',
    agreeTerms: false,
    agreePrivacy: false,
    agreeMarketing: false
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [errorText, setErrorText] = useState('');

  const countryCodes = [
    { code: '+82', country: 'KR', name: '대한민국' },
    { code: '+1', country: 'US', name: '미국' },
    { code: '+81', country: 'JP', name: '일본' },
    { code: '+86', country: 'CN', name: '중국' },
    { code: '+44', country: 'GB', name: '영국' },
    { code: '+33', country: 'FR', name: '프랑스' },
    { code: '+49', country: 'DE', name: '독일' },
    { code: '+39', country: 'IT', name: '이탈리아' },
    { code: '+34', country: 'ES', name: '스페인' },
    { code: '+31', country: 'NL', name: '네덜란드' },
    { code: '+32', country: 'BE', name: '벨기에' },
    { code: '+41', country: 'CH', name: '스위스' },
    { code: '+43', country: 'AT', name: '오스트리아' },
    { code: '+45', country: 'DK', name: '덴마크' },
    { code: '+46', country: 'SE', name: '스웨덴' },
    { code: '+47', country: 'NO', name: '노르웨이' },
    { code: '+48', country: 'PL', name: '폴란드' },
    { code: '+351', country: 'PT', name: '포르투갈' },
    { code: '+30', country: 'GR', name: '그리스' },
    { code: '+358', country: 'FI', name: '핀란드' },
    { code: '+61', country: 'AU', name: '호주' },
    { code: '+65', country: 'SG', name: '싱가포르' },
    { code: '+66', country: 'TH', name: '태국' },
    { code: '+84', country: 'VN', name: '베트남' },
    { code: '+63', country: 'PH', name: '필리핀' },
    { code: '+60', country: 'MY', name: '말레이시아' },
    { code: '+62', country: 'ID', name: '인도네시아' },
    { code: '+95', country: 'MM', name: '미얀마' },
    { code: '+855', country: 'KH', name: '캄보디아' },
    { code: '+856', country: 'LA', name: '라오스' },
    { code: '+673', country: 'BN', name: '브루나이' },
    { code: '+670', country: 'TL', name: '동티모르' },
    { code: '+91', country: 'IN', name: '인도' },
  ];

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorText('')
    setShowSuccess(false)
    if (formData.password !== formData.confirmPassword) {
      setErrorText('Passwords do not match.');
      return;
    }

    // if (formData.withdrawalPin.length !== 6) {
    //   alert('Withdrawal PIN must be exactly 6 digits.');
    //   return;
    // }

    if (!formData.agreeTerms || !formData.agreePrivacy) {
      setErrorText('Please agree to the required terms.');
      return;
    }

    let signupResult = await signup(formData.username, formData.email, formData.password);
    console.log(signupResult)
    if (signupResult) {
      setShowSuccess(true)
      setTimeout(() => navigate('/login'), 2000);
    } else {
      setErrorText('Sign up failed. ' + error);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value, type } = e.target;
    const checked = (e.target as HTMLInputElement).checked;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0D0E11] via-[#111319] to-[#16181D] flex items-center justify-center py-8 sm:py-12 px-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-6 sm:mb-8">
          <Link to="/" className="inline-block">
            <div className="flex items-center justify-center gap-2 mb-2">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-slot-machine-line text-[#FFD349] text-3xl"></i>
              </div>
              <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold bg-gradient-to-r from-[#FFD349] to-[#FFC107] bg-clip-text text-transparent" style={{ fontFamily: 'Orbitron, sans-serif' }}>
                DIGITWISE SLOT
              </h1>
            </div>
          </Link>
          <p className="text-white/70 mt-2 text-xs sm:text-sm" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            Create your new account
          </p>
        </div>

        {/* Sign Up Form */}
        <div className="bg-[#1a1c24] border border-[#FFD349]/20 rounded-xl sm:rounded-2xl p-5 sm:p-6 md:p-8 shadow-2xl">
          <h2 className="text-xl sm:text-2xl font-bold text-white mb-4 sm:mb-6 text-center" style={{ fontFamily: 'Orbitron, sans-serif' }}>
            Sign Up
          </h2>
          {showSuccess && (
            <div className="mb-6 p-4 bg-green-500/20 border border-green-500/50 rounded-lg text-green-200 text-sm flex items-center gap-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              <i className="ri-checkbox-circle-fill text-xl"></i>
              Sign up successful! Please login.
            </div>
          )}

          {errorText && (
            <div className="mb-6 p-4 bg-red-500/20 border border-red-500/50 rounded-lg text-red-200 text-sm flex items-center gap-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              <i className="ri-checkbox-circle-fill text-xl"></i>
              {errorText}
            </div>
          )}
          <form onSubmit={handleSubmit} className="space-y-3 sm:space-y-4 md:space-y-5">
            {/* Email */}
            <div>
              <label className="block text-white/80 text-xs sm:text-sm font-medium mb-1.5 sm:mb-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Email <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full bg-[#0D0E11] border border-[#FFD349]/30 rounded-lg px-3 sm:px-4 py-2 sm:py-2.5 md:py-3 text-white text-xs sm:text-sm focus:outline-none focus:border-[#FFD349] transition-colors"
                placeholder="example@email.com"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              />
            </div>

            {/* Referral Code */}
            {/* <div>
              <label className="block text-white/80 text-xs sm:text-sm font-medium mb-1.5 sm:mb-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Referral Code <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="referralCode"
                value={formData.referralCode}
                onChange={handleChange}
                required
                className="w-full bg-[#0D0E11] border border-[#FFD349]/30 rounded-lg px-3 sm:px-4 py-2 sm:py-2.5 md:py-3 text-white text-xs sm:text-sm focus:outline-none focus:border-[#FFD349] transition-colors"
                placeholder="Enter referral code"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              />
            </div> */}

            {/* Username */}
            <div>
              <label className="block text-white/80 text-xs sm:text-sm font-medium mb-1.5 sm:mb-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Username <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="username"
                value={formData.username}
                onChange={handleChange}
                required
                className="w-full bg-[#0D0E11] border border-[#FFD349]/30 rounded-lg px-3 sm:px-4 py-2 sm:py-2.5 md:py-3 text-white text-xs sm:text-sm focus:outline-none focus:border-[#FFD349] transition-colors"
                placeholder="Enter your username"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              />
            </div>

            {/* Password */}
            <div>
              <label className="block text-white/80 text-xs sm:text-sm font-medium mb-1.5 sm:mb-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Password <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  className="w-full bg-[#0D0E11] border border-[#FFD349]/30 rounded-lg px-3 sm:px-4 py-2 sm:py-2.5 md:py-3 text-white text-xs sm:text-sm focus:outline-none focus:border-[#FFD349] transition-colors pr-10 sm:pr-12"
                  placeholder="At least 8 characters"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                  minLength={8}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-2 sm:right-3 top-1/2 -translate-y-1/2 text-white/50 hover:text-white transition-colors cursor-pointer"
                >
                  <i className={`ri-eye-${showPassword ? 'off' : ''}-line text-base sm:text-lg`}></i>
                </button>
              </div>
            </div>

            {/* Confirm Password */}
            <div>
              <label className="block text-white/80 text-xs sm:text-sm font-medium mb-1.5 sm:mb-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Confirm Password <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <input
                  type={showConfirmPassword ? 'text' : 'password'}
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  required
                  className="w-full bg-[#0D0E11] border border-[#FFD349]/30 rounded-lg px-3 sm:px-4 py-2 sm:py-2.5 md:py-3 text-white text-xs sm:text-sm focus:outline-none focus:border-[#FFD349] transition-colors pr-10 sm:pr-12"
                  placeholder="Re-enter your password"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                  minLength={8}
                />
                <button
                  type="button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  className="absolute right-2 sm:right-3 top-1/2 -translate-y-1/2 text-white/50 hover:text-white transition-colors cursor-pointer"
                >
                  <i className={`ri-eye-${showConfirmPassword ? 'off' : ''}-line text-base sm:text-lg`}></i>
                </button>
              </div>
            </div>

            {/* USDT Wallet Address */}
            {/* <div>
              <label className="block text-white/80 text-xs sm:text-sm font-medium mb-1.5 sm:mb-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                My Wallet Address (TRC-20) <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="usdtWallet"
                value={formData.usdtWallet}
                onChange={handleChange}
                required
                className="w-full bg-[#0D0E11] border border-[#FFD349]/30 rounded-lg px-3 sm:px-4 py-2 sm:py-2.5 md:py-3 text-white text-xs sm:text-sm focus:outline-none focus:border-[#FFD349] transition-colors"
                placeholder="Enter TRC-20 wallet address"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              />
            </div> */}

            {/* Withdrawal PIN */}
            {/* <div>
              <label className="block text-white/80 text-xs sm:text-sm font-medium mb-1.5 sm:mb-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Withdrawal PIN (6 digits) <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <input
                  type={showWithdrawalPin ? 'text' : 'password'}
                  name="withdrawalPin"
                  value={formData.withdrawalPin}
                  onChange={handleChange}
                  required
                  className="w-full bg-[#0D0E11] border border-[#FFD349]/30 rounded-lg px-3 sm:px-4 py-2 sm:py-2.5 md:py-3 text-white text-xs sm:text-sm focus:outline-none focus:border-[#FFD349] transition-colors pr-10 sm:pr-12"
                  placeholder="Enter 6-digit PIN"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                  pattern="[0-9]{6}"
                  maxLength={6}
                  inputMode="numeric"
                />
                <button
                  type="button"
                  onClick={() => setShowWithdrawalPin(!showWithdrawalPin)}
                  className="absolute right-2 sm:right-3 top-1/2 -translate-y-1/2 text-white/50 hover:text-white transition-colors cursor-pointer"
                >
                  <i className={`ri-eye-${showWithdrawalPin ? 'off' : ''}-line text-base sm:text-lg`}></i>
                </button>
              </div>
            </div> */}

            {/* Phone Number */}
            {/* <div>
              <label className="block text-white/80 text-xs sm:text-sm font-medium mb-1.5 sm:mb-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Phone Number <span className="text-red-500">*</span>
              </label>
              <div className="flex gap-2">
                <select
                  name="phoneCountryCode"
                  value={formData.phoneCountryCode}
                  onChange={handleChange}
                  className="bg-[#0D0E11] border border-[#FFD349]/30 rounded-lg px-2 sm:px-3 py-2 sm:py-2.5 md:py-3 text-white text-xs sm:text-sm focus:outline-none focus:border-[#FFD349] transition-colors cursor-pointer"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  {countryCodes.map((country) => (
                    <option key={country.code} value={country.code}>
                      {country.code} ({country.country})
                    </option>
                  ))}
                </select>
                <input
                  type="tel"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  required
                  className="flex-1 bg-[#0D0E11] border border-[#FFD349]/30 rounded-lg px-3 sm:px-4 py-2 sm:py-2.5 md:py-3 text-white text-xs sm:text-sm focus:outline-none focus:border-[#FFD349] transition-colors"
                  placeholder="Enter phone number"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                />
              </div>
            </div> */}

            {/* Terms Agreement */}
            <div className="space-y-2 sm:space-y-3 pt-2">
              <div className="flex items-start gap-2 sm:gap-3">
                <input
                  type="checkbox"
                  name="agreeTerms"
                  checked={formData.agreeTerms}
                  onChange={handleChange}
                  className="mt-0.5 sm:mt-1 w-3.5 h-3.5 sm:w-4 sm:h-4 accent-[#FFD349] cursor-pointer flex-shrink-0"
                  id="agreeTerms"
                />
                <label htmlFor="agreeTerms" className="text-white/80 text-xs sm:text-sm cursor-pointer" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  I agree to the Terms of Service <span className="text-red-500">*</span>
                </label>
              </div>

              <div className="flex items-start gap-2 sm:gap-3">
                <input
                  type="checkbox"
                  name="agreePrivacy"
                  checked={formData.agreePrivacy}
                  onChange={handleChange}
                  className="mt-0.5 sm:mt-1 w-3.5 h-3.5 sm:w-4 sm:h-4 accent-[#FFD349] cursor-pointer flex-shrink-0"
                  id="agreePrivacy"
                />
                <label htmlFor="agreePrivacy" className="text-white/80 text-xs sm:text-sm cursor-pointer" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  I agree to the Privacy Policy <span className="text-red-500">*</span>
                </label>
              </div>

              <div className="flex items-start gap-2 sm:gap-3">
                <input
                  type="checkbox"
                  name="agreeMarketing"
                  checked={formData.agreeMarketing}
                  onChange={handleChange}
                  className="mt-0.5 sm:mt-1 w-3.5 h-3.5 sm:w-4 sm:h-4 accent-[#FFD349] cursor-pointer flex-shrink-0"
                  id="agreeMarketing"
                />
                <label htmlFor="agreeMarketing" className="text-white/80 text-xs sm:text-sm cursor-pointer" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  I agree to receive marketing communications (Optional)
                </label>
              </div>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="w-full bg-gradient-to-r from-[#FFD349] to-[#FFC107] hover:shadow-[0px_0px_20px_rgba(255,211,73,0.6)] text-black font-bold py-2.5 sm:py-3 md:py-3.5 rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer text-sm sm:text-base mt-4 sm:mt-6"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              {isLoading ? (
                <span className="flex items-center justify-center gap-2">
                  <i className="ri-loader-4-line animate-spin"></i>
                  Signing up...
                </span>
              ) : (
                'Sign Up'
              )}
            </button>
          </form>

          {/* Login Link */}
          <div className="mt-4 sm:mt-6 text-center">
            <p className="text-white/60 text-xs sm:text-sm" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Already have an account?{' '}
              <Link to="/login" className="text-[#FFD349] hover:text-[#FFC107] font-semibold transition-colors">
                Login
              </Link>
            </p>
          </div>
        </div>

        {/* Back to Home */}
        <div className="text-center mt-4 sm:mt-6">
          <Link
            to="/"
            className="text-white/60 hover:text-white text-xs sm:text-sm transition-colors inline-flex items-center gap-2"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            <i className="ri-arrow-left-line"></i>
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
